// extracted by mini-css-extract-plugin
module.exports = {"button":"_2U8Jg"};